// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let window: any;

export type MenuForm = {
    id: string;
    label: string;
    icon: string;
    path: string;
    panel: string;
};

export type MenuPanel = {
    name: string;
    id: string;
    panel: MenuForm[];
};

const __SUPRESS_ACTIVE_MENU__: string = window.__SUPRESS_ACTIVE_MENU__;
const __MENU_PANELS_COMPACT_MODE__: string = window.__MENU_PANELS_COMPACT_MODE__;
const __MENU_PANELS__: MenuPanel[] = window.__MENU_PANELS__;
const __PRETTY_USER_NAME__: string = window.__PRETTY_USER_NAME__;
const __MAIN_MENU_LAYOUT_MODE__: string = window.__MAIN_MENU_LAYOUT_MODE__;

export {
    __MAIN_MENU_LAYOUT_MODE__,
    __MENU_PANELS__,
    __MENU_PANELS_COMPACT_MODE__,
    __PRETTY_USER_NAME__,
    __SUPRESS_ACTIVE_MENU__,
};
